export default __webpack_public_path__ + "static/media/5-1_infocircle.6c182fc9.svg";